import { useState, useEffect } from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from 'react';
import Slider from 'react-slick';
import '../NosRealisations.css';
import image2 from '../assets/parking-enrobe-min.png';
import image3 from '../assets/hydrocarbure-mi.jpg';
import headerImage from '../assets/réalisation-min.png';
import murAvant from '../assets/mur-avant-min.jpg';
import murApres from '../assets/mur-apres-min.jpg';
import Footer from '../components/Footer';
import { FaInstagram, FaTiktok } from 'react-icons/fa'; // Icons from react-icons


const NosRealisations = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [isFixed, setIsFixed] = useState(true);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true, // Affiche les flèches de navigation
  };

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      const popup = document.querySelector('.popup-social');
      if (footer && popup) {
        const footerTop = footer.getBoundingClientRect().top;
        if (footerTop < window.innerHeight) {
          setIsFixed(false); // Lorsque le footer est visible, on arrête le défilement
        } else {
          setIsFixed(true); // Sinon, le pop-up reste fixe en bas
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll); // Nettoyage de l'événement
  }, []);

  return (
    <div id="nos-realisations" className="realisations-container">
      {/* Header */}
      <div className="header-container">
        <img src={headerImage} alt="Réalisation Header" className="header-image" />
        <div className="text-overlay-realisation">
          <div className="overlay-realisation">
          </div>
        </div>
      </div>
      <div className="presentation-section">
        <h2 className="presentation-title">Nos Réalisations</h2>
        <div className="presentation-separator-line"></div>
        <p className="presentation-description">
          Découvrez quelques-unes de nos réalisations, illustrant l'expertise et le savoir-faire de notre équipe.
          Nous avons travaillé sur une variété de projets allant de la construction de <strong>structures durables</strong> à l'aménagement de
          surfaces, en passant par des solutions de <strong>gestion des hydrocarbures</strong>, le tout dans un souci constant de <strong>qualité</strong> et de
          respect de l'environnement. Nos travaux sont conçus pour répondre aux besoins spécifiques de chaque client tout en
          garantissant la <strong>sécurité</strong> et la <strong>performance</strong>.
        </p>
      </div>
      <section className="realisations-section-grid">
        <div className="realisations-grid">
          {/* Section 1 */}
          {/*<div className="grid-item">
            <div className="realisations-text1">
              <h2>Construction d’un mur</h2>
              <p style={{ fontSize: '1.1rem' }}>
                <strong>Construction d’un mur de soutènement</strong> avec clôture semi-rigide.
                Nous avons construit un mur de soutènement en blocs à bancher, avec une finition en <strong>enduit cimenté</strong> pour une meilleure protection et un rendu sobre.
                Une <strong>clôture semi-rigide</strong> complète l’ensemble, assurant une délimitation efficace et discrète.
              </p>
            </div>
            <div className="slider-container">
              <Slider {...sliderSettings}>
                <div>
                  <img src={murAvant} alt="Mur avant" className="realisations-image1" />
                </div>
                <div>
                  <img src={murApres} alt="Mur après" className="realisations-image1" />
                </div>
              </Slider>
            </div>
          </div> */}

          {/* Section 2 */}
          <div className="grid-item">
            <div className="realisations-text2">
              <h2>Enrobé</h2>
              <p style={{ fontSize: '1.1rem' }}>
                <strong>Application d’un enrobé noir 0/6</strong> dans un dépôt pour bus. Nous avons posé un enrobé noir 0/6 sur 3300 m² au finisher, 
                garantissant une surface régulière et adaptée au passage intensif des bus. Les travaux ont commencé par le <strong>rabotage complet du sol existant</strong>, 
                optimisant ainsi l’adhérence et la durabilité du nouvel enrobé.
              </p>
            </div>
            <img src={image2} alt="Réalisation 2" className="realisations-image2" />
          </div>

          {/* Section 3 */}
          <div className="grid-item">
            <div className="realisations-text3">
              <h2>Installation d’une cuve séparatrice d’hydrocarbures</h2>
              <p style={{ fontSize: '1.1rem' }}>
                Nous avons installé <strong>une cuve séparatrice d’hydrocarbures</strong> conçue pour limiter l’impact des rejets sur l’environnement. 
                Cet équipement joue un rôle essentiel dans la protection des sols et des nappes phréatiques en retenant les <strong>polluants</strong>
                issus des hydrocarbures avant leur évacuation.
              </p>
            </div>
            <img src={image3} alt="Réalisation 3" className="realisations-image3" style={{ width: '60%' }} />
          </div>
        </div>

     
      </section>
      <Footer />
    </div>
  );
};

export default NosRealisations;
